import { createContext, useContext, useState } from "react";

const SidebarDeskContext = createContext();

export const SidebarDeskProvider = ({ children }) => {
    const [sidebarDeskOpen, setSidebarDeskOpen] = useState(false);

    const toggleSidebarDesk = () => {
        setSidebarDeskOpen(!sidebarDeskOpen);
    };

    return (
        <SidebarDeskContext.Provider
            value={{ sidebarDeskOpen, toggleSidebarDesk }}
        >
            {children}
        </SidebarDeskContext.Provider>
    );
};

export const useSidebarDesk = () => {
    return useContext(SidebarDeskContext);
};
